import { useState } from 'react'
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap'
import InputMask from 'react-input-mask'
import { FaPlus, FaTrash, FaUserPlus } from 'react-icons/fa'

const ESTADO_CIVIL_OPTIONS = ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)', 'União Estável']
const PARENTESCO_OPTIONS = ['Cônjuge', 'Filho(a)', 'Enteado(a)', 'Outro']

const FORM_INICIAL = {
  // Dados pessoais
  nome: '',
  estadoCivil: '',
  dataNascimento: '',
  naturalidade: '',
  cpf: '',
  rg: '',
  // Endereço
  logradouro: '',
  numero: '',
  bairro: '',
  cidade: '',
  cep: '',
  // Contato
  fone: '',
  email: '',
  // Dados profissionais
  empresa: '',
  admissao: '',
  funcao: '',
  tipoContrato: '',
  dataFiliacao: '',
  foiSocio: '',
  empresaAnterior: '',
}

const DEPENDENTE_VAZIO = () => ({ parentesco: '', nome: '', dataNascimento: '' })

function SectionTitle({ children }) {
  return (
    <Col xs={12} className="mb-3">
      <h6 className="associe-section-title">{children}</h6>
    </Col>
  )
}

function FieldGroup({ label, error, children }) {
  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold">{label}</Form.Label>
      {children}
      {error && <div className="associe-field-error">{error}</div>}
    </Form.Group>
  )
}

function Associe() {
  const [form, setForm] = useState(FORM_INICIAL)
  const [dependentes, setDependentes] = useState([])
  const [errors, setErrors] = useState({})
  const [enviado, setEnviado] = useState(false)

  const set = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }))
    if (errors[field]) setErrors(prev => { const e = { ...prev }; delete e[field]; return e })
  }

  // --- Dependentes ---
  const addDependente = () => setDependentes(prev => [...prev, DEPENDENTE_VAZIO()])

  const removeDependente = (idx) =>
    setDependentes(prev => prev.filter((_, i) => i !== idx))

  const setDependente = (idx, field, value) =>
    setDependentes(prev =>
      prev.map((dep, i) => i === idx ? { ...dep, [field]: value } : dep)
    )

  // --- Validação ---
  const validate = () => {
    const e = {}
    if (!form.nome.trim())           e.nome = 'Campo obrigatório'
    if (!form.estadoCivil)           e.estadoCivil = 'Selecione o estado civil'
    if (!form.dataNascimento || form.dataNascimento.includes('_')) e.dataNascimento = 'Data inválida'
    if (!form.naturalidade.trim())   e.naturalidade = 'Campo obrigatório'
    if (!form.cpf || form.cpf.includes('_')) e.cpf = 'CPF inválido'
    if (!form.rg || form.rg.includes('_'))   e.rg = 'RG inválido'
    if (!form.logradouro.trim())     e.logradouro = 'Campo obrigatório'
    if (!form.numero.trim())         e.numero = 'Campo obrigatório'
    if (!form.bairro.trim())         e.bairro = 'Campo obrigatório'
    if (!form.cidade.trim())         e.cidade = 'Campo obrigatório'
    if (!form.cep || form.cep.includes('_')) e.cep = 'CEP inválido'
    if (!form.fone || form.fone.includes('_')) e.fone = 'Telefone inválido'
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'E-mail inválido'
    if (!form.empresa.trim())        e.empresa = 'Campo obrigatório'
    if (!form.admissao || form.admissao.includes('_')) e.admissao = 'Data inválida'
    if (!form.funcao.trim())         e.funcao = 'Campo obrigatório'
    if (!form.tipoContrato)          e.tipoContrato = 'Selecione o tipo de contrato'
    if (!form.dataFiliacao || form.dataFiliacao.includes('_')) e.dataFiliacao = 'Data inválida'
    if (!form.foiSocio)              e.foiSocio = 'Selecione uma opção'
    if (form.foiSocio === 'sim' && !form.empresaAnterior.trim()) e.empresaAnterior = 'Informe a empresa anterior'

    dependentes.forEach((dep, idx) => {
      if (!dep.parentesco)    e[`dep_${idx}_parentesco`] = 'Obrigatório'
      if (!dep.nome.trim())   e[`dep_${idx}_nome`] = 'Obrigatório'
      if (!dep.dataNascimento || dep.dataNascimento.includes('_')) e[`dep_${idx}_dataNascimento`] = 'Data inválida'
    })

    return e
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const erros = validate()
    if (Object.keys(erros).length > 0) {
      setErrors(erros)
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return
    }
    // TODO: integrar com API / EmailService
    console.log('Proposta enviada:', { ...form, dependentes })
    setEnviado(true)
    setForm(FORM_INICIAL)
    setDependentes([])
    setErrors({})
  }

  if (enviado) {
    return (
      <Row className="justify-content-center" style={{ marginTop: '3rem', marginBottom: '3rem' }}>
        <Col xs={12} md={8} lg={6} className="text-center">
          <Alert variant="success">
            <Alert.Heading>Proposta enviada com sucesso!</Alert.Heading>
            <p>Entraremos em contato em breve. Obrigado pelo interesse em se associar ao Metal Bauru.</p>
            <Button className="btn-primary-red border-0" onClick={() => setEnviado(false)}>
              Nova proposta
            </Button>
          </Alert>
        </Col>
      </Row>
    )
  }

  return (
    <Container>
      <Row style={{ marginTop: '2rem', marginBottom: '3rem' }}>
        <Col xs={12}>
          <h2 className="section-title">Proposta de Sócio</h2>
          <p className="text-muted mb-4">
            Preencha o formulário abaixo para se tornar um associado do Sindicato dos Metalúrgicos de Bauru e Região.
          </p>
        </Col>

        {Object.keys(errors).length > 0 && (
          <Col xs={12}>
            <Alert variant="danger" className="mb-4">
              Corrija os campos destacados antes de enviar o formulário.
            </Alert>
          </Col>
        )}

        <Col xs={12}>
          <Form noValidate onSubmit={handleSubmit}>

            {/* ── DADOS PESSOAIS ── */}
            <div className="associe-section mb-4">
              <Row>
                <SectionTitle>Dados Pessoais</SectionTitle>

                <Col xs={12}>
                  <FieldGroup label="Nome completo *" error={errors.nome}>
                    <Form.Control
                      value={form.nome}
                      onChange={e => set('nome', e.target.value)}
                      isInvalid={!!errors.nome}
                      placeholder="Nome completo"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={6}>
                  <FieldGroup label="Estado civil *" error={errors.estadoCivil}>
                    <Form.Select
                      value={form.estadoCivil}
                      onChange={e => set('estadoCivil', e.target.value)}
                      isInvalid={!!errors.estadoCivil}
                    >
                      <option value="">Selecione...</option>
                      {ESTADO_CIVIL_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                    </Form.Select>
                  </FieldGroup>
                </Col>

                <Col xs={12} md={3}>
                  <FieldGroup label="Data de nascimento *" error={errors.dataNascimento}>
                    <Form.Control
                      as={InputMask}
                      mask="99/99/9999"
                      value={form.dataNascimento}
                      onChange={e => set('dataNascimento', e.target.value)}
                      isInvalid={!!errors.dataNascimento}
                      placeholder="DD/MM/AAAA"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={3}>
                  <FieldGroup label="Naturalidade *" error={errors.naturalidade}>
                    <Form.Control
                      value={form.naturalidade}
                      onChange={e => set('naturalidade', e.target.value)}
                      isInvalid={!!errors.naturalidade}
                      placeholder="Cidade/UF"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={4}>
                  <FieldGroup label="CPF *" error={errors.cpf}>
                    <Form.Control
                      as={InputMask}
                      mask="999.999.999-99"
                      value={form.cpf}
                      onChange={e => set('cpf', e.target.value)}
                      isInvalid={!!errors.cpf}
                      placeholder="000.000.000-00"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={4}>
                  <FieldGroup label="RG *" error={errors.rg}>
                    <Form.Control
                      as={InputMask}
                      mask="99.999.999-9"
                      value={form.rg}
                      onChange={e => set('rg', e.target.value)}
                      isInvalid={!!errors.rg}
                      placeholder="00.000.000-0"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={4}>
                  <FieldGroup label="Fone *" error={errors.fone}>
                    <Form.Control
                      as={InputMask}
                      mask="(99) 99999-9999"
                      value={form.fone}
                      onChange={e => set('fone', e.target.value)}
                      isInvalid={!!errors.fone}
                      placeholder="(14) 99999-9999"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={8}>
                  <FieldGroup label="E-mail *" error={errors.email}>
                    <Form.Control
                      type="email"
                      value={form.email}
                      onChange={e => set('email', e.target.value)}
                      isInvalid={!!errors.email}
                      placeholder="seuemail@exemplo.com"
                    />
                  </FieldGroup>
                </Col>
              </Row>
            </div>

            {/* ── ENDEREÇO ── */}
            <div className="associe-section mb-4">
              <Row>
                <SectionTitle>Endereço</SectionTitle>

                <Col xs={12} md={3}>
                  <FieldGroup label="CEP *" error={errors.cep}>
                    <Form.Control
                      as={InputMask}
                      mask="99999-999"
                      value={form.cep}
                      onChange={e => set('cep', e.target.value)}
                      isInvalid={!!errors.cep}
                      placeholder="00000-000"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={7}>
                  <FieldGroup label="Logradouro *" error={errors.logradouro}>
                    <Form.Control
                      value={form.logradouro}
                      onChange={e => set('logradouro', e.target.value)}
                      isInvalid={!!errors.logradouro}
                      placeholder="Rua, Avenida..."
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={2}>
                  <FieldGroup label="Número *" error={errors.numero}>
                    <Form.Control
                      value={form.numero}
                      onChange={e => set('numero', e.target.value)}
                      isInvalid={!!errors.numero}
                      placeholder="Nº"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={5}>
                  <FieldGroup label="Bairro *" error={errors.bairro}>
                    <Form.Control
                      value={form.bairro}
                      onChange={e => set('bairro', e.target.value)}
                      isInvalid={!!errors.bairro}
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={7}>
                  <FieldGroup label="Cidade *" error={errors.cidade}>
                    <Form.Control
                      value={form.cidade}
                      onChange={e => set('cidade', e.target.value)}
                      isInvalid={!!errors.cidade}
                    />
                  </FieldGroup>
                </Col>
              </Row>
            </div>

            {/* ── DADOS PROFISSIONAIS ── */}
            <div className="associe-section mb-4">
              <Row>
                <SectionTitle>Dados Profissionais</SectionTitle>

                <Col xs={12} md={8}>
                  <FieldGroup label="Empresa *" error={errors.empresa}>
                    <Form.Control
                      value={form.empresa}
                      onChange={e => set('empresa', e.target.value)}
                      isInvalid={!!errors.empresa}
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={4}>
                  <FieldGroup label="Admissão na empresa *" error={errors.admissao}>
                    <Form.Control
                      as={InputMask}
                      mask="99/99/9999"
                      value={form.admissao}
                      onChange={e => set('admissao', e.target.value)}
                      isInvalid={!!errors.admissao}
                      placeholder="DD/MM/AAAA"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={6}>
                  <FieldGroup label="Função *" error={errors.funcao}>
                    <Form.Control
                      value={form.funcao}
                      onChange={e => set('funcao', e.target.value)}
                      isInvalid={!!errors.funcao}
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={3}>
                  <FieldGroup label="Tipo de contrato *" error={errors.tipoContrato}>
                    <Form.Select
                      value={form.tipoContrato}
                      onChange={e => set('tipoContrato', e.target.value)}
                      isInvalid={!!errors.tipoContrato}
                    >
                      <option value="">Selecione...</option>
                      <option value="horista">Horista</option>
                      <option value="mensalista">Mensalista</option>
                    </Form.Select>
                  </FieldGroup>
                </Col>

                <Col xs={12} md={3}>
                  <FieldGroup label="Data da filiação *" error={errors.dataFiliacao}>
                    <Form.Control
                      as={InputMask}
                      mask="99/99/9999"
                      value={form.dataFiliacao}
                      onChange={e => set('dataFiliacao', e.target.value)}
                      isInvalid={!!errors.dataFiliacao}
                      placeholder="DD/MM/AAAA"
                    />
                  </FieldGroup>
                </Col>

                <Col xs={12} md={4}>
                  <FieldGroup label="Já foi sócio do sindicato? *" error={errors.foiSocio}>
                    <Form.Select
                      value={form.foiSocio}
                      onChange={e => set('foiSocio', e.target.value)}
                      isInvalid={!!errors.foiSocio}
                    >
                      <option value="">Selecione...</option>
                      <option value="sim">Sim</option>
                      <option value="nao">Não</option>
                    </Form.Select>
                  </FieldGroup>
                </Col>

                {form.foiSocio === 'sim' && (
                  <Col xs={12} md={8}>
                    <FieldGroup label="Empresa na qual era sócio *" error={errors.empresaAnterior}>
                      <Form.Control
                        value={form.empresaAnterior}
                        onChange={e => set('empresaAnterior', e.target.value)}
                        isInvalid={!!errors.empresaAnterior}
                      />
                    </FieldGroup>
                  </Col>
                )}
              </Row>
            </div>

            {/* ── DEPENDENTES ── */}
            <div className="associe-section mb-4">
              <Row>
                <SectionTitle>Dependentes</SectionTitle>

                {dependentes.length === 0 && (
                  <Col xs={12}>
                    <p className="text-muted mb-3" style={{ fontSize: '0.875rem' }}>
                      Nenhum dependente adicionado. Clique em "Adicionar dependente" para incluir cônjuge ou filhos.
                    </p>
                  </Col>
                )}

                {dependentes.map((dep, idx) => (
                  <Col xs={12} key={idx}>
                    <div className="associe-dependente">
                      <div className="associe-dependente-header">
                        <span className="fw-bold">Dependente {idx + 1}</span>
                        <button
                          type="button"
                          className="associe-remove-btn"
                          onClick={() => removeDependente(idx)}
                          aria-label="Remover dependente"
                        >
                          <FaTrash /> Remover
                        </button>
                      </div>
                      <Row>
                        <Col xs={12} md={3}>
                          <FieldGroup label="Parentesco *" error={errors[`dep_${idx}_parentesco`]}>
                            <Form.Select
                              value={dep.parentesco}
                              onChange={e => setDependente(idx, 'parentesco', e.target.value)}
                              isInvalid={!!errors[`dep_${idx}_parentesco`]}
                            >
                              <option value="">Selecione...</option>
                              {PARENTESCO_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                            </Form.Select>
                          </FieldGroup>
                        </Col>
                        <Col xs={12} md={6}>
                          <FieldGroup label="Nome completo *" error={errors[`dep_${idx}_nome`]}>
                            <Form.Control
                              value={dep.nome}
                              onChange={e => setDependente(idx, 'nome', e.target.value)}
                              isInvalid={!!errors[`dep_${idx}_nome`]}
                            />
                          </FieldGroup>
                        </Col>
                        <Col xs={12} md={3}>
                          <FieldGroup label="Data de nascimento *" error={errors[`dep_${idx}_dataNascimento`]}>
                            <Form.Control
                              as={InputMask}
                              mask="99/99/9999"
                              value={dep.dataNascimento}
                              onChange={e => setDependente(idx, 'dataNascimento', e.target.value)}
                              isInvalid={!!errors[`dep_${idx}_dataNascimento`]}
                              placeholder="DD/MM/AAAA"
                            />
                          </FieldGroup>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}

                <Col xs={12}>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    className="associe-add-dep-btn"
                    onClick={addDependente}
                  >
                    <FaUserPlus className="me-2" />
                    Adicionar dependente
                  </Button>
                </Col>
              </Row>
            </div>

            {/* ── AUTORIZAÇÃO ── */}
            <div className="associe-section mb-4">
              <Row>
                <SectionTitle>Autorização</SectionTitle>
                <Col xs={12}>
                  <div className="associe-autorizacao-texto">
                    Autorizo a Firma Empregadora a descontar em folha de pagamento as mensalidades
                    subsequentes, de acordo com o artigo 545 parágrafo único da CLT.
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── ENVIAR ── */}
            <Row className="justify-content-center">
              <Col xs={12} md={6} lg={4} className="text-center">
                <Button
                  type="submit"
                  className="btn-primary-red border-0 w-100"
                  size="lg"
                >
                  <FaPlus className="me-2" />
                  Enviar proposta
                </Button>
              </Col>
            </Row>

          </Form>
        </Col>
      </Row>
    </Container>
  )
}

export default Associe